<template>
  <v-app>
    <v-content v-if="!loged"
      style="position: absolute;top: 0;botto:0;z-index: 99;height: 100vh;width:100vw;flex: 1; background-color: rgba(255,255,255,0.9);align-items: center;">
      <LoadingLogo/>
    </v-content>
    <v-content>
      <Header v-if="!['Demo', 'MudanzaDemo'].includes($route.name)"/>
      <transition name="router-anim">
        <router-view v-if="loged"></router-view>
      </transition>
      <!-- <Register/> -->
      <Login/>
      <!-- <InvitacionExpress/> -->
      <!-- <Modals/> -->
      <Footer v-if="!['Demo', 'MudanzaDemo'].includes($route.name)"/>
      <IndexModal />
    </v-content>
  </v-app>
</template>

<style>

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.1s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 0.1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

</style>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'

import Header from './components/Site/Header'
import Footer from './components/Site/Footer'
import Register from './components/Site/Register'
import Login from './components/Site/Login'
// import InvitacionExpress from './components/Site/InvitacionExpress'
import LoadingLogo from './helpers/LoadingLogo'
import IndexModal from './components/Modals/Index'
//import Home from './components/Home'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Register,
    Login,
    LoadingLogo,
    IndexModal,
    // InvitacionExpress
  },
  mounted(){
    this.firebaseLogin()
    console.log("MONTADITO")
  },
  methods: {
    async firebaseLogin(){
      const self = this
      self.loged = true
      /* let uid = await localStorage.getItem('uid')
      if(!uid){
        uid = + new Date()
        uid = uid.toString()
        localStorage.setItem('uid', uid)
      } */
      firebase.auth().onAuthStateChanged(async function(user) {
        console.log(user)
        if (user) {
          // User is signed in.
          console.log('logged')
          const userData = user
          console.log(userData)
          self.loged = true
          if (user.email != null) {
            self.$store.state.idCliente = user.uid
            let uid = user.uid
            console.log('esta funcionando')
            // await firebase.auth().signInWithCustomToken(uid)
            const usuario = firebase.auth().currentUser
            console.log(usuario)
            self.loged = true
          }
        } /* else {
          // No user is signed in.
          console.log('notLoged')
          // self.firebaseLogin()
          let uid = await localStorage.getItem('uid')
            if(!uid){
              uid = + new Date()
              uid = uid.toString()
              localStorage.setItem('uid', uid)
            }
          const createCustomLoginToken = firebase.functions().httpsCallable('createCustomLoginToken')
          const datos = {uid}
          createCustomLoginToken(datos)
            .then(async ({data}) =>{
              await firebase.auth().signInWithCustomToken(data)
              self.loged = true
            })
            .catch(httpsError => {
              console.log("createCustomLoginToken error", httpsError)
              // self.firebaseLogin()
            })
            
        } */
      });
      const user = firebase.auth().currentUser
      /* if(!user){
        const createCustomLoginToken = firebase.functions().httpsCallable('createCustomLoginToken')
        const datos = {uid}
        createCustomLoginToken(datos)
          .then(async ({data}) =>{
            await firebase.auth().signInWithCustomToken(data)
            // self.loged = true
          })
          .catch(httpsError => {
            console.log("createCustomLoginToken error", httpsError)
            self.firebaseLogin()
          })
      } */
      
    }    
  },
  data () {
    return {
      loged: false
    }
  }
}
</script>
